const apiUrl = process.env.REACT_APP_API_URL;

export const signin = async (obj) => {
    const url = `${apiUrl}/api/auth/signin`;
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(obj)
    };
    try {
        const response = await fetch(url, requestOptions);
        return await response.json();
    } catch (error) {
        return { result: false }
    }
};

export const resetPassword = async (obj) => {
    const url = `${apiUrl}/api/auth/resetPassword`;
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(obj)
    };
    try {
        const response = await fetch(url, requestOptions);
        return await response.json();
    } catch (error) {
        return { result: false }
    }
};

export const checkIfUserHasAPwdRequest = async (token) => {
    const url = `${apiUrl}/api/auth/checkIfUserHasAPwdRequest/${token}`;
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
    };
    try {
        const response = await fetch(url, requestOptions);
        return await response.json();
    } catch (error) {
        return { result: false }
    }
};

export const updatePassword = async (obj) => {
    const url = `${apiUrl}/api/auth/updatePassword`;
    const requestOptions = {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(obj)
    };
    try {
        const response = await fetch(url, requestOptions);
        return await response.json();
    } catch (error) {
        return { result: false }
    }
};

export const getFailedAttemptsReport = async (page = 1, limit = 20) => {
    const token = sessionStorage.getItem('token');
    const url = `${apiUrl}/api/auth/getFailedAttemptsReport?page=${page}&limit=${limit}`;
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || 'America/Mexico_City';
    const requestOptions = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
            'Time-Zone': tz,
        },
    };

    try {
        const response = await fetch(url, requestOptions);
        return await response.json();
    } catch (error) {
        console.error("Error al obtener intentos fallidos:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};